import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { ContractDetailView } from '@/features/contract-management/components/ContractDetailView';

export const Route = createFileRoute('/_authenticated/contract-management/contracts/$id')({
  component: ContractDetailRoute,
});

function ContractDetailRoute() {
  const { id } = Route.useParams();
  const navigate = useNavigate();

  return (
    <ContractDetailView
      contractId={id}
      onBack={() => navigate({ to: '/contract-management' })}
    />
  );
}
